import * as React from 'react'
import { Controller } from 'react-hook-form'
import { Label } from '../components/Label.tsx'
import { createPopupWidget } from '../components/popupHelper.tsx'
import { get20YearOptions, Months } from './options.tsx'

interface Props {
    control: any
    formField: string
    title: string,
    errors: Record<string, any>
    required?: boolean
    disabled: boolean
}

export const ExpirationDate: React.FC<Props> = (props) => {
    const { control, formField, title, errors, required, disabled } = props
    const [open, setOpen] = React.useState('')

    const rules = required ? {
        required: {
            value: true,
            message: 'Required'
        },
    } : {}

    const expDate = (curVal : {month: string, year: string}) => {
        return (
            <div className={'flex justify-start items-center gap-2'}>
            {createPopupWidget({
                name: `${formField}.month`,
                title: 'Month',
                options: Months,
                cols: 3,
                isSub: true,
                center: true,
                setOpen,
                open,
                control,
                errors,
                btnSize: '2xl',
                curVal: curVal.month,
                compareAsNum: true,
                disabled,
            })}
            {createPopupWidget({
                name: `${formField}.year`,
                title: 'Year',
                options: get20YearOptions(),
                cols: 4,
                isSub: true,
                center: true,
                setOpen,
                open,
                control,
                errors,
                btnSize: 'year',
                curVal: curVal.year,
                disabled,
            })}
        </div>)
    }

    return (
        <div>
            <Label formField={formField} title={title} errors={errors}/>
            <div className={'w-full'}>
                <Controller
                    name={formField}
                    rules={rules}
                    control={control}
                    render={({ field }) => {
                        return expDate(field.value)
                    }}
                />
            </div>
        </div>
    )
}
